export const MEDIA_CONTENT_AUDIO = 1
export const MEDIA_CONTENT_VIDEO = 2
export const MEDIA_CONTENT_IMAGE = 3
export const MEDIA_CONTENT_PDF = 4
export const MEDIA_CONTENT_TEXT = 50
export const MEDIA_CONTENT_ATTACHMENT = 99

export const HUB_AUTO = 1 //has to be at least 1.  Need a sample row to grab its height to detect page height for auto size

// full text search = elastic search

export const HUB_ACTION_STATE = Object.freeze({
  NONE: 'NONE',
  REFRESH: 'REFRESH',
  ADD_ROW: 'ADD_ROW',
  DELETE_ROW: 'DELETE_ROW',
  MOVE_ROW: 'MOVE_ROW',
  ELASTIC_SEARCH: 'ELASTIC_SEARCH',
  FILTER: 'FILTER',
  LOADING: 'LOADING',
  INITIALIZE: 'INITIALIZE',
  MODIFY_ROW: 'MODIFY_ROW',
  SELECT_CHECKBOX: 'SELECT_CHECKBOX',
  EXPAND_ROW: 'EXPAND_ROW'
})

export const HUB_COLLAPSIBLE_ROW_STATE = Object.freeze({
  UNINITIALIZED: 0,
  LOADING: 1,
  LOADED: 2
})

export const HUB_SEARCH_AREA_FOCUS = Object.freeze({
  NONE: 0,
  FULL_TEXT_SEARCH: 1,
  FILTER: 2
})

export const HUB_FILTER_TYPE = Object.freeze({
  MULTI_VAL_SELECTOR: 0,
  CHECKBOX: 1,
  FOLDER_TREE_SELECTOR: 2
})

export const HUB_CHECKBOX_STATE = Object.freeze({
  EMPTY: 0,
  TICK: 1,
  CROSS: 2
})

export const USER_FOLDER_PERMISSIONS = Object.freeze({
  NONE: 0,
  READ: 1,
  CREATE: 2,
  MODIFY: 4,
  DELETE: 8,
  REORDER: 16
})

export const HUB_OBJECT_COLLECTION = 101;
export const HUB_OBJECT_FOLDER = 102;
export const HUB_OBJECT_NEWSPLANNER = 103;
export const HUB_OBJECT_SHOW = 201;
export const HUB_OBJECT_STORY = 202;
export const HUB_OBJECT_ELEMENT = 301;
export const HUB_USERS = 401;
export const HUB_PRODUCTION_GROUP = 501;
export const HUB_METADATA = 601;
export const HUB_METADATA_PER_NEWSITEM = 701;
export const HUB_VOCABULARY = 701;